<span class="user-info" *ngIf="currentUserEmail">
  <mat-icon aria-hidden="false" aria-label="User icon">account_circle</mat-icon>
  <p>{{ currentUserEmail }}</p>
</span>
<span class="user-info" *ngIf="studentDisplay as s">
  <mat-icon aria-hidden="false" aria-label="User icon">account_circle</mat-icon>
  <p><span class="username">{{ s.username }}</span> · {{ s.schoolName }}</p>
</span>
